import actionCable from 'actioncable';
import { playMonitoringSound } from './monitoring_sounds';

let consumer: actionCable.Cable | null = null;
let soundProfileId: number | null = null;
let soundSubscription: any = null;
let academySubscription: any = null;
const soundListeners = new Set<() => void>();

const createSoundSubscription = (profileId: number): void => {
  if (!consumer || soundSubscription) return;
  soundSubscription = consumer.subscriptions.create(
    { channel: 'MonitoredChatsChannelSound', user_id: profileId },
    {
      received: (data?: { sound?: string }) => {
        playMonitoringSound(data?.sound);
        soundListeners.forEach((listener) => listener());
      },
    },
  );
};

export const getConsumer = (): actionCable.Cable => {
  if (!consumer) {
    const { REACT_APP_API_ENDPOINT } = process.env;
    consumer = actionCable.createConsumer(`${REACT_APP_API_ENDPOINT}/cable`);
    soundSubscription = null;

    if (soundProfileId) {
      createSoundSubscription(soundProfileId);
    }
  }
  return consumer;
};

export const disconnectConsumer = (): void => {
  if (consumer) {
    consumer.disconnect();
    consumer = null;
  }
  soundProfileId = null;
  soundSubscription = null;
  academySubscription = null;
};

export const setupAcademyLiveSubscription = (onReceived: (live: any) => void): void => {
  const cable = getConsumer();
  if (academySubscription) return;

  academySubscription = cable.subscriptions.create(
    { channel: 'AcademyLiveChannel' },
    {
      received: (data: any) => onReceived(data?.live ?? null),
    },
  );
};

export const setupSoundSubscription = (profileId: number): void => {
  soundProfileId = profileId;
  getConsumer();
  createSoundSubscription(profileId);
};

export const onMonitoringSound = (listener: () => void): (() => void) => {
  soundListeners.add(listener);

  return () => {
    soundListeners.delete(listener);
  };
};
